export const parseTextParams = (textValue: string, paramObject: any) => {
  return Object.keys(paramObject).reduce((text, key) => text.replace(`$\{${key}}`, paramObject[key]), textValue);
};

export const isHtml = RegExp.prototype.test.bind(/(<([^>]+)>)/i);

export const clearWhitespace = (input: string) => input.replace(/\s/g, '');

export const toCamelCase = (snakeCaseString: string) => snakeCaseString.split('_').reduce((a, b) => a + b[0].toUpperCase() + b.slice(1));

export const capitalize = (s: string) => {
  if (!s || typeof s !== 'string') {
    return '';
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const validateImei = (s: string) => {
  const exp = /^[0-9]{15}$/;
  if (!exp.test(s)) {
    return false;
  }
  let sum = 0;
  let mul = 2;
  const l = 14;
  for (let i = 0; i < l; i++) {
    const digit = s.substring(l - i - 1, l - i);
    const tp = parseInt(digit, 10) * mul;
    if (tp >= 10) {
      sum += (tp % 10) + 1;
    } else {
      sum += tp;
    }
    if (mul === 1) {
      mul++;
    } else {
      mul--;
    }
  }
  const chk = (10 - (sum % 10)) % 10;
  return chk === parseInt(s.substring(14, 15), 10);
};

export const normalizeId = (id: string = '', addHash: boolean = false): string => {
  const regex = new RegExp(/^[A-Za-z]+[\w\-:.]*$/);
  const valid = regex.test(id);
  if (new RegExp(/^\d/).test(id)) {
    id = `ID_${id}`;
  }
  const validId = valid ? id : id.replace(/\W/g, '_');
  return addHash ? `#${validId}` : validId;
};
